import { useState } from "react";
import {useNavigate} from 'react-router-dom';
import { useAuthContext } from "..";
import "./signup.css";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [image, setImage] = useState("");

  const {signup} = useAuthContext();

  const redirect = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    signup(email,password,name,image);
  };

  return (
    <div className="parent-container-signup">
    <div className={"auth-container-signup "}>
      <h1 className="container-title-signup">New User? <span>SignUp</span></h1>
    <div className="signup-conatiner">
      <p>Create an account using mail and password</p>
      <form className="signup-form" onSubmit={handleSubmit}>
        <label for="name">
          <span>&nbsp;&nbsp;Name</span>
          <input
            id="name"
            name="name"
            type="text"
            placeholder="Name"
            required
            onChange={(e) => setName(e.target.value)}
          />
        </label>
        <label for="email">
          <span>&nbsp;&nbsp;E-Mail</span>
          <input
            id="email"
            type="email"
            name="email"
            placeholder="Email"
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label for="photo">
          Upload Your Picture<br/>
          <input
            type="file"
            id="photo"
            name="photo"
            accept="image/*"
            placeholder="Upload Image"
            required
            onChange={(e) => setImage(e.target.value)}
          />
        </label>
        <label for="password">
          <span>&nbsp;&nbsp;Enter Password</span>
          <input
            type="password"
            id="password"
            name="password"
            minLength={8}
            placeholder="Password"
            required
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <button type="submit">Sign Up</button>
      </form>
    </div>
    <div className="redirect-to-login">Already have an account? <span onClick={() => redirect('/ecomapp')}>Login</span></div>
    </div>
    </div>
  );
};

export default Signup;
